import { queryCompanyFengyunDetail } from '@/services/company';

export default {
  namespace: 'Devices_fengyun',

  state: {
    data: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(queryCompanyFengyunDetail, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            ...data.data,
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
